import React,{useEffect,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import { fetchVoicemailDestination,deleteVoicemailDestination,addNewVoicemailDestination } from '../../../redux/action'
import deleteIcon from '../../../assets/images/delete-icon.svg'
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg'

export default function VoicemailDestination() {
  const settings=useSelector((state)=>state.settings)
  const dispatch=useDispatch()
  const [currentInfo,setCurrentInfo]=useState({email:''})
  

  const getVoicemailDestinations=()=>{
    dispatch(fetchVoicemailDestination())
  }

  useEffect(()=>{
   getVoicemailDestinations()
  },[])

  return (
    <>

<div className="row mt-4">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">
                <div className="row pt-1">
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                        <div className="d-flex justify-content-end align-items-center">
                            <button className="secondary-btn" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#createContactCanvas" aria-controls="createContactCanvas">
                                Add Email
                            </button>
                        </div>
                    </div>
                </div>    



                <table class="mt-2 table table-borderless">
    <thead>
        <tr>            
            <th className="align-middle" style={{width:'90%'}} scope="col">Email Address</th>
            <th className="align-middle" style={{width:'10%'}} scope="col">Actions</th>
        </tr>
    </thead>
    <tbody>
     {settings && settings.voicemail_destinations && settings.voicemail_destinations.length>0 && settings.voicemail_destinations.map((contact)=>(
        
         <tr key={contact.id}>
             <td className="align-middle">{contact.email}</td>
             <td className="align-middle">
                    <img width="30" onClick={()=>dispatch(deleteVoicemailDestination(contact.id))} src={deleteIcon} className="ms-2 img-fluid"/>
             </td>
         </tr>
        
        ))
        }
        </tbody>
    </table>



            </div>
        </div>




        <div className="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas" aria-labelledby="createContactCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="createContactCanvasLabel">Add Email</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas">
                <img src={sliderCloseIcon} className="img-fluid"/>
            </button>
        </div>
        <div className="offcanvas-body">
            <div  className="tags mb-3">
                <input style={{marginBottom:"30px"}} value={currentInfo.email} onChange={(e)=>setCurrentInfo({email:e.target.value})}  type="email"  name="email"   className="form-control slider-inputs" placeholder="Email address"/>
            </div>
            
            
            
          
            <div className="d-flex justify-content-end mt-4">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas" >Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={()=>{dispatch(addNewVoicemailDestination(currentInfo));setCurrentInfo({email:""})}}>Add</button>
            </div>
        </div>
    </div>




   
    </>
  )
}
